import { render, staticRenderFns } from "./DotAlert.vue?vue&type=template&id=723b8fd2&scoped=true&"
import script from "./DotAlert.vue?vue&type=script&lang=js&"
export * from "./DotAlert.vue?vue&type=script&lang=js&"
import style0 from "./DotAlert.vue?vue&type=style&index=0&id=723b8fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723b8fd2",
  null
  
)

export default component.exports